//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PATTERNS_VALIDATION } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import DatastudioDatasourceService from '@/apps/data-platform/services/visualization/datastudio_datasource_service';
export default {
  name: 'FormAssignTemporalOwner',
  props: {
    tplToWork: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    relativeResourceNames: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    fromEmail: {
      type: String,
      required: false,
      default: undefined
    },
    type: {
      type: String,
      required: false,
      default: 'table'
    },
    isForAllOwners: {
      type: Boolean,
      required: false,
      default: false
    },
    records: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    source: {
      type: String,
      required: false,
      default: "bigquery"
    }
  },
  data: function data() {
    return {
      toSave: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      defaultFields: null,
      columnFields: [],
      invalid: false,
      invalidDate: false,
      showAlert: false,
      message: '',
      deployMessage: false,
      tipoMensaje: '',
      overlay: false,
      dismissSecs: 5,
      dismissCountDown: 0
    };
  },
  computed: {
    hideDate: function hideDate() {
      return this.relativeResourceNames && this.relativeResourceNames.length > 0;
    }
  },
  created: function created() {
    // define if is for all owners
    // set save to send object
    console.log("tpltoworkasd", this.tplToWork);
    console.log("source", this.source);
    this.toSave.operator = '';
    this.toSave.startDate = utils.getToDayString();
    this.toSave.endDate = '';

    // if is for all users
    if (!this.isForAllOwners && this.type === 'table') {
      this.setTableToSave();
    }
  },
  methods: {
    setTableToSave: function setTableToSave() {
      if (!this.tplToWork || !Object.keys(this.tplToWork).length) {
        return;
      }
      var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.objects.tags);
      // Separe defaultTemplate and Columnfields
      this.defaultFields = separeValues.defaultFields;
      this.columnFields = separeValues.columnFields;
      this.toSave.index_node = this.tplToWork.item.index_node;
      this.toSave.domain_table = this.tplToWork.item.domain_table;
      this.toSave.relativeResourceName = this.tplToWork.item.relativeResourceName;
      this.toSave.fields = this.tplToWork.objects.tags;
      this.toSave.tableReference = this.tplToWork.item.tableReference;
    },
    fechas: function fechas() {
      if (this.toSave.endDate) {
        var inicio = new Date(this.toSave.startDate);
        var final = new Date(this.toSave.endDate);
        var resultado = final - inicio;
        if (resultado >= 0) {
          this.invalidDate = false;
        } else {
          this.invalidDate = true;
        }
      }
    },
    prepareToAllOwner: function prepareToAllOwner() {
      var _this = this;
      this.deployMessage = false;
      var toSaveCopy = utils.cloneJSON(this.toSave);
      console.log("asd", toSaveCopy);
      toSaveCopy.startDate = utils.dateBrowserToService(toSaveCopy.startDate);
      toSaveCopy.endDate = utils.dateBrowserToService(toSaveCopy.endDate);
      var operator_email = this.fromEmail || window.userInfo.email;
      var email = toSaveCopy.operator;
      var startDate = toSaveCopy.startDate;
      var endDate = toSaveCopy.endDate;
      var operator = operator_email.trim();
      var relativeResourceNames = this.relativeResourceNames;
      var source = this.source;
      var params = {
        email: email,
        startDate: startDate,
        endDate: endDate,
        operator: operator,
        relativeResourceNames: relativeResourceNames,
        source: source
      };

      // send to multiple assign flow
      this.overlay = true;
      this.promiseAssignmentAllTables(params).then(function (response) {
        if (response.code === 200) {
          if (response.success === false) {
            _this.deployMessage = true;
            _this.tipoMensaje = 'danger';
            _this.message = response.message;
            tasks.toast.error(_this.message);
          } else if (response.success === true) {
            _this.deployMessage = true;
            _this.tipoMensaje = 'success';
            _this.message = response.message;
            tasks.toast.success(_this.message);
            var self = _this;
            self.$emit('submit', response);
          }
        } else {
          //this.prepareToAllOwner()
        }
        _this.overlay = false;
      }).catch(function (e) {
        _this.overlay = false;
        utils.printError(e);
        //this.prepareToAllOwner()
      });
    },
    promiseAssignmentAllTables: function promiseAssignmentAllTables(params) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.relativeResourceNames && _this2.relativeResourceNames.length > 0) {
          TablesService.eternalAssignment(params).then(function (response) {
            resolve(response);
          }, function (err) {
            reject(err);
          });
        } else {
          TablesService.temporaryAssignment(params).then(function (response) {
            resolve(response);
          }, function (err) {
            reject(err);
          });
        }
      });
    },
    prepareToOwner: function prepareToOwner() {
      var _this3 = this;
      // set copy later instance new
      var toSaveCopy = utils.cloneJSON(this.toSave);
      console.log("temp_owner", toSaveCopy);
      toSaveCopy.startDate = utils.dateBrowserToService(toSaveCopy.startDate);
      toSaveCopy.endDate = utils.dateBrowserToService(toSaveCopy.endDate);
      var relativeResourceName = toSaveCopy.relativeResourceName;
      var email = toSaveCopy.operator;
      var endDate = toSaveCopy.endDate;
      var startDate = toSaveCopy.startDate;
      var tags = toSaveCopy.fields;
      var index_node = toSaveCopy.index_node;
      var domain_table = toSaveCopy.domain_table;
      var source = this.tplToWork.item.source ? this.tplToWork.item.source : "bigquery";
      var params = {
        resourceName: relativeResourceName,
        email: email,
        endDate: endDate,
        startDate: startDate,
        tags: tags,
        index_node: index_node,
        domain_table: domain_table,
        source: source
      };

      // send to listFlow tasks
      this.overlay = true;
      MyAccessService.createTempOwner(params).then(function (response) {
        if (response.code === 200) {
          if (!response.success) {
            _this3.deployMessage = true;
            _this3.tipoMensaje = 'danger';
            _this3.message = response.message;
            tasks.toast.error(_this3.message);
          } else if (response.success === true) {
            _this3.deployMessage = true;
            _this3.tipoMensaje = 'success';
            _this3.message = response.message;
            tasks.toast.success("Operador asignado correctamente.");
            //this.$toast.success("Hecho")
            var self = _this3;
            self.$emit('submit', response.data);
          }
        }
        _this3.overlay = false;
      }).catch(function (e) {
        _this3.overlay = false;
        tasks.toast.error(e);
        //utils.printError(e)
        _this3.prepareToOwner();
      });
    },
    prepareToOwnerTableau: function prepareToOwnerTableau() {
      var _this4 = this;
      this.toSave['tableau_type'] = this.type;
      var records = [this.tplToWork];
      if (this.records && this.records.length) {
        records = this.records.filter(function (record) {
          return record.environment === 'prod';
        });
      }
      var data = {
        domain: window.userInfo.domain,
        records: records,
        data_temporal: this.toSave
      };
      TableauDatasourceService.tableauTemporalDataOperator(data).then(function (response) {
        if (response.code === 200) {
          _this4.$emit(_this4.type === 'datasource' ? 'submitDatasource' : 'submitDashboard', response);
          tasks.toast.success("Operador asignado correctamente.");
          //this.$toast.success("Hecho")
        } else {
          _this4.dismissCountDown = _this4.dismissSecs;
        }
      }).catch(function (response) {
        console.warn(response);
      });
    },
    prepareToOwnerPowerbiDataset: function prepareToOwnerPowerbiDataset() {
      var _this5 = this;
      this.toSave['powerbi_type'] = this.type;
      var records = [this.tplToWork];
      if (this.records && this.records.length) {
        records = this.records.filter(function (record) {
          return record.environment === 'prod';
        });
      }
      var data = {
        domain: window.userInfo.domain,
        records: records,
        data_temporal: this.toSave
      };
      BiDatasetService.setTemporalDataOperator(data).then(function (response) {
        if (response.code === 200) {
          _this5.$emit(_this5.type === 'dataset' ? 'submitDataset' : 'submitReport', response);
          tasks.toast.success("Operador asignado correctamente.");
          //this.$toast.success("Hecho")
        } else {
          _this5.dismissCountDown = _this5.dismissSecs;
        }
      }).catch(function (response) {
        console.warn(response);
      });
    },
    prepareToOwnerPowerbiReport: function prepareToOwnerPowerbiReport() {
      var _this6 = this;
      this.toSave['powerbi_type'] = this.type;
      var records = [this.tplToWork];
      if (this.records && this.records.length) {
        records = this.records.filter(function (record) {
          return record.environment === 'prod';
        });
      }
      var data = {
        domain: window.userInfo.domain,
        records: records,
        data_temporal: this.toSave
      };
      BiReportService.setTemporalDataOperator(data).then(function (response) {
        if (response.code === 200) {
          _this6.$emit(_this6.type === 'dataset' ? 'submitDataset' : 'submitReport', response);
          tasks.toast.success("Operador asignado correctamente.");
          //this.$toast.success("Hecho")
        } else {
          _this6.dismissCountDown = _this6.dismissSecs;
        }
      }).catch(function (response) {
        console.warn(response);
      });
    },
    prepareToOwnerDatastudioReport: function prepareToOwnerDatastudioReport() {
      var _this7 = this;
      var records = [this.tplToWork];
      if (this.records && this.records.length) {
        records = this.records.filter(function (record) {
          return record.environment === 'prod' && record.data_operator == window.userInfo.email;
        });
      }
      var data = {
        domain: window.userInfo.domain,
        records: records,
        data_temporal: this.toSave
      };
      DatastudioReportService.setTemporalDataOperator(data).then(function (response) {
        if (response.code === 200) {
          _this7.$emit('submitReport', response);
          tasks.toast.success("Operador asignado correctamente.");
          //this.$toast.success("Hecho")
        } else {
          _this7.dismissCountDown = _this7.dismissSecs;
        }
      }).catch(function (response) {
        console.warn(response);
      });
    },
    prepareToOwnerDatastudioDatasource: function prepareToOwnerDatastudioDatasource() {
      var _this8 = this;
      var records = [this.tplToWork];
      if (this.records && this.records.length) {
        records = this.records.filter(function (record) {
          return record.environment === 'prod' && record.data_operator == window.userInfo.email;
        });
      }
      var data = {
        domain: window.userInfo.domain,
        records: records,
        data_temporal: this.toSave
      };
      DatastudioDatasourceService.setTemporalDataOperator(data).then(function (response) {
        if (response.code === 200) {
          _this8.$emit('submitReport', response);
          tasks.toast.success("Operador asignado correctamente.");
          //this.$toast.success("Hecho")
        } else {
          _this8.dismissCountDown = _this8.dismissSecs;
        }
      }).catch(function (response) {
        console.warn(response);
      });
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) return;
      if (this.type === 'table') {
        if (this.isForAllOwners) {
          this.prepareToAllOwner();
        } else {
          this.prepareToOwner();
        }
      } else if (['datasource', 'workbook'].includes(this.type)) {
        this.prepareToOwnerTableau();
      } else if (['dataset'].includes(this.type)) {
        this.prepareToOwnerPowerbiDataset();
      } else if ('report' == this.type) {
        this.prepareToOwnerPowerbiReport();
      } else if ('report_gds' == this.type) {
        this.prepareToOwnerDatastudioReport();
      } else if ('datasource_gds' == this.type) {
        this.prepareToOwnerDatastudioDatasource();
      }
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};